import { enableProdMode } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { LoginComponent } from './login/login.component';
import { ChangePasswordComponent } from './change-password/change-password.component';
import { HomeComponent } from './home/home.component';
import { CartellinoComponent } from './cartellino/cartellino.component';
import { AdministrationComponent } from './administration/administration.component';
import { AssenzeComponent } from './assenze/assenze.component';
import { AuthAccessProvider } from './core/core.auth';
import { UfficioComponent } from './ufficio/ufficio.component';
import { DocumentsComponent } from "./documents/documents.component";
import { CommesseComponent } from './gestione-commesse/gestione-commesse.component';
 
const appRoutes: Routes = [
    { path: 'login', component: LoginComponent },
    { path: '', component: HomeComponent, canActivate: [AuthAccessProvider] },
    { path: 'cartellino', component: CartellinoComponent, canActivate: [AuthAccessProvider] },
    { path: 'admin', component: AdministrationComponent, canActivate: [AuthAccessProvider] },
    { path: 'absences', component: AssenzeComponent, canActivate: [AuthAccessProvider] },
    { path: 'ufficio', component: UfficioComponent, canActivate: [AuthAccessProvider]},
	{ path: "documents", component: DocumentsComponent, canActivate: [AuthAccessProvider] },
    { path: 'gestione-commesse', component: CommesseComponent, canActivate: [AuthAccessProvider] },
    { path: 'cambio-password', component: ChangePasswordComponent, canActivate: [AuthAccessProvider] },
    { path: '**', redirectTo: '' }
];
 
export const routing = RouterModule.forRoot(appRoutes,  { useHash: true });


// WEBPACK FOOTER //
// ./src/app/app.routing.ts